var map = {
	"./board-man.jpg": 284,
	"./bucket-king.jpg": 757,
	"./cookie-monster.jpg": 471,
	"./fly-swatter.jpg": 246,
	"./loverboy.jpg": 509,
	"./mvp.jpg": 624,
	"./the-dealer.jpg": 168,
	"./villain.jpg": 971
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 977;